import { Module } from "wrapper6";
import Glide from '@glidejs/glide';
import { ArrowControls } from '../utils/_glide-plugins';
import { debounce } from '../utils/_debounce';

export default class RoomsCoverSlider extends Module {
  ready() {
    this.NAVIGATION = document.querySelector('.navigation');

    if (document.querySelector('.mtt-rooms-cover__slides')) {
      const OPTIONS = {
        type: 'carousel',
        rewind: false,
        gap: 120,
        peek: this.calculateSliderPeek(),
        arrowClasses: {
          next: 'slider-arrow--right',
          back: 'slider-arrow--left'
        },
        breakpoints: {
          1920: {
            gap: 120
          },
          1750: {
            gap: 64
          },
          1600: {
            gap: 32
          },
          1100: {
            gap: 16
          }
        }
      }

      const SLIDER = new Glide('.mtt-rooms-cover__slides .glide', OPTIONS);

      SLIDER.mount({ ArrowControls });
      this.arrowPosition();
      this.resizer(SLIDER);
    }
  }

  calculateSliderPeek() {
    return (window.innerWidth - this.NAVIGATION.offsetWidth) / 2;
  }

  arrowPosition() {
    const ARROWS = document.querySelectorAll('.mtt-rooms-cover__slides .slider-arrow');
    const BIG_IMAGE = document.querySelector('.rooms-cover-slide__big-image');

    for (let i = 0; i < ARROWS.length; i++) {
      const ARROW = ARROWS[i];
      ARROW.style.top = `${BIG_IMAGE.offsetHeight / 2}px`;
    }
  }

  resizer(slider) {
    window.addEventListener('resize', debounce(() => {
      slider.update({ peek: this.calculateSliderPeek() });
      this.arrowPosition();
    }, 100));
  }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_rooms-cover-slider.js